import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
export function AppRouter() {
  return <BrowserRouter data-id="element-12">
      <Routes data-id="element-13">
        <Route path="/" element={<App data-id="element-15" />} data-id="element-14" />
        <Route path="/login" element={<Login data-id="element-17" />} data-id="element-16" />
        <Route path="/signup" element={<SignUp data-id="element-19" />} data-id="element-18" />
        <Route path="/terms" element={<Terms data-id="element-21" />} data-id="element-20" />
        <Route path="/privacy" element={<Privacy data-id="element-23" />} data-id="element-22" />
      </Routes>
    </BrowserRouter>;
}